/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

export enum ProcessType {
  INCIDENT_MANAGEMENT = "INCIDENT_MANAGEMENT",
  SERVICE_REQUEST_MANAGEMENT = "SERVICE_REQUEST_MANAGEMENT",
  PATCHING = "PATCHING",
  BACKUP = "BACKUP",
  CHANGE_MANAGEMENT = "CHANGE_MANAGEMENT",
  PROBLEM_MANAGEMENT = "PROBLEM_MANAGEMENT",
}

export enum ProcessTypeDisplay {
  INCIDENT_MANAGEMENT = "Incident management",
  SERVICE_REQUEST_MANAGEMENT = "Service request",
  PATCHING = "Patching",
  BACKUP = "Backup",
  CHANGE_MANAGEMENT = "Change management",
  PROBLEM_MANAGEMENT = "Problem management",
}
